import { render, staticRenderFns } from "./BizBusinessinfoAuditList.vue?vue&type=template&id=652a164c&"
import script from "./BizBusinessinfoAuditList.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoAuditList.vue?vue&type=script&lang=js&"
import style0 from "./BizBusinessinfoAuditList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports